import { UNDER_REVISION_SENTENCE } from '../../utils/resourceRevision';

export default function RevisionNotice({ className = '' }: { className?: string }) {
  return (
    <p className={`flex items-start gap-2 text-sm font-medium text-gray-900 ${className}`}>
      <span className="mt-1.5 h-2 w-2 rounded-sm bg-warning flex-shrink-0" aria-hidden />
      <span>{UNDER_REVISION_SENTENCE}</span>
    </p>
  );
}
